import { Map, OrderedSet } from 'immutable';

import * as overviewTypes from './../test-overview/types';
import * as types from './types';

const initialState = Map({
  errorCountByDate: OrderedSet(),
  aggregatedErrors: OrderedSet(),
  testsByError: Map({
    isLoading: false,
    error: null,
    data: Map(),
  }),
});

const testErrorReducer = (state = initialState, { type, payload, error, meta }) => {
  switch (type) {
    case overviewTypes.GET_TEST_TRENDS.SUCCESS:
      return state.withMutations((newState) => {
        const errors = payload.buckets.map((bucket) => {
          const errored = bucket.aggs.status.find((status) => (
            status.name === 'errored'
          ));
          return { name: bucket.datetime, errorCount: errored ? errored.count : 0 };
        });
        newState.set('errorCountByDate', OrderedSet(errors));
      });
    case types.GET_AGGREGATED_TEST_ERRORS.REQUEST:
      return state.set('aggregatedErrors', initialState.get('aggregatedErrors'));
    case types.GET_AGGREGATED_TEST_ERRORS.SUCCESS:
      return state.withMutations((newState) => {
        // sort the output first
        payload.buckets.sort((itemLeft, itemRight) => itemLeft.count < itemRight.count);
        const errors = OrderedSet(
          payload.buckets.map((item) => ({
            name: item.name,
            count: item.count,
            items: item.items,
          })),
        );
        newState.set('aggregatedErrors', errors);
      });
    case types.CLEANUP_TEST_ERROR:
      return initialState;
    case types.GET_TESTS_BY_ERROR.REQUEST:
      return state.setIn(['testsByError', 'isLoading'], true);
    case types.GET_TESTS_BY_ERROR.FAILURE:
      return state.withMutations((newState) => {
        newState.setIn(['testsByError', 'isLoading'], false);
        newState.setIn(['testsByError', 'error'], error);
      });
    case types.GET_TESTS_BY_ERROR.SUCCESS:
      return state.withMutations((newState) => {
        newState.setIn(['testsByError', 'data', meta.errorName], payload.items);

        newState.setIn(['testsByError', 'isLoading'], false);
        newState.setIn(['testsByError', 'error'], null);
      });
    default:
      return state;
  }
};

export default testErrorReducer;
export { initialState };
